module.exports = __webpack_public_path__ + "media/images/logos/greenhouse-43238e35b25d864dacdece85e2467d36.png";